import { useEffect, useState } from "react";

export function useIsPortraitMobile(breakpoint = 640) {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const check = () => {
      const isMobile = window.innerWidth < breakpoint;
      const isPortrait = window.innerHeight > window.innerWidth;
      setShowMessage(isMobile && isPortrait);
    };

    check(); // initial run
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, [breakpoint]);

  return showMessage;
}
